'use client';

import { c as _c } from "react/compiler-runtime";
import { useThemeMode } from '@precis-digital/kurama/AppProvider';
import { resolveThemeAsset, type ThemeAssetSrc } from 'shared/assets/resolveThemeAsset';

/**
 * Resolves a theme asset URL for the current Kurama theme mode.
 * Returns `undefined` when `src` is nullish (e.g. optional Chip `avatarSrc`).
 */
export function useResolvedThemeAsset(src: ThemeAssetSrc): string;
export function useResolvedThemeAsset(src: ThemeAssetSrc | null | undefined): string | undefined;
export function useResolvedThemeAsset(src) {
  const $ = _c(3);
  const {
    mode
  } = useThemeMode();
  if (src == null) {
    return;
  }
  let t0;
  if ($[0] !== mode || $[1] !== src) {
    t0 = resolveThemeAsset(src, {
      mode
    });
    $[0] = mode;
    $[1] = src;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}